export const fonts = {
  body: '"Fellix", system-ui, -apple-system, BlinkMacSystemFont, sans-serif',
  heading: '"Fellix", system-ui, -apple-system, BlinkMacSystemFont, sans-serif',
  monospace:
    '"Fellix", system-ui, -apple-system, BlinkMacSystemFont, sans-serif',
};
